export default __webpack_public_path__ + "static/media/clock.21fd7d1f.svg";